import React from 'react';
import styled from 'styled-components';

import HeroSection from 'components/HeroSection';
import Stack from 'components/Stack';
import Container from 'components/Container';
import Text from 'components/Text';

const Section = styled(HeroSection)`
  text-align: center;
  padding: 6rem 1.5rem;
`;

export default function Hero() {
  return (
    <Section variant="secondary">
      <Container size="sm">
        <Stack gap="0.5rem">
          <Text as="h1" variant="hero">
            Sleuth Trust Center
          </Text>
          <Text color="textGray">
            Security is very important to us. We follow industry best practices
            for protecting your organization.
          </Text>
        </Stack>
      </Container>
    </Section>
  );
}
